import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface IProps {
  hoverless?: boolean
  rootClass?: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KGlassCard' },
  __name: 'KGlassCard',
  props: {
    hoverless: { type: Boolean, default: false },
    rootClass: { default: '' }
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["k-glass-card q-pa-lg cursor-pointer rounded-24 transition", [{ 'k-glass-card__hoverless': __props.hoverless }, __props.rootClass]])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})